'use strict';

import {addFormControlSelect2, fnToastrFormError, printResponse} from "../jquery-functions-library";
import {element_exists} from "../functions";

export var fnTaskTemplatesActions = function () {

    var tableName = '#datatable-task-templates';

    if (!element_exists(tableName)) return false;

    var lang = allLangFiles['task-templates'];
    var formsLang = allLangFiles.forms;


    function checkFreq() {
        $('.task-group').each(function () {
            var oddOrEvenWeekContainer = $(this).find('#odd-or-even-week-container');
            var startOrEndMonthContainer = $(this).find('#start-or-end-month-container');
            var frequency = $(this).find('#frequency');

            oddOrEvenWeekContainer.hide();
            startOrEndMonthContainer.hide();

            if (frequency.val() == 2) {
                oddOrEvenWeekContainer.show();
            }

            if (frequency.val() == 4) {
                startOrEndMonthContainer.show();
            }

            frequency.off('change').on('change', function () {
                // selected biweekly
                if ($(this).val() == 2) {
                    oddOrEvenWeekContainer.show();
                } else {
                    oddOrEvenWeekContainer.hide();
                }

                // selected monthly
                if ($(this).val() == 4) {
                    startOrEndMonthContainer.show();
                } else {
                    startOrEndMonthContainer.hide();
                }
            });
        });
    }

    moment.locale('da');
    $.ajaxSetup({headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')}});

    $(document).off('click', '#btn-create-task-template');
    $(document).on('click', '#btn-create-task-template', function (e) {
        e.preventDefault();

        var url = $(this).attr('data-href');

        var modalName = '#modal-create-task-template';

        if (!element_exists(modalName)) {

            $.ajax({
                url: url,
                success: function (response) {

                    $('.dynamic-modal-container').append(response);

                    var modal = $(modalName);

                    modal.modal('show');

                    $('select[name*=responsible_id]').select2({width: '271px', height: '75%'}).addClass('form-control');
                    addFormControlSelect2();

                    var form = $('#form-create-task-template');

                    checkFreq();

                    form.off().on('submit', function (e) {
                        e.preventDefault();

                        var formData = $(this).serialize();
                        var url = this.action;

                        $.ajax({
                            type: 'POST',
                            url: url,
                            data: formData,
                            success: function (response) {
                                if (!response.error) {
                                    modal.modal('hide');
                                    $(tableName).DataTable().ajax.reload(null, false);
                                }
                                printResponse(response);
                            },
                            error: function (response) {
                                if (response.status === 422) {
                                    var data = JSON.parse(response.responseText);
                                    for (var error in data.errors) {
                                        toastr.error(data.errors[error][0]);
                                    }
                                }
                            },
                        })
                    });

                    modal.on('hidden.bs.modal', function () {
                        modal.remove();
                    });
                }
            });
        }
    });
    $(document).off('click', tableName + ' .btn-delete');
    $(document).on('click', tableName + ' .btn-delete', function (e) {

        e.preventDefault();

        var url = $(this).attr('data-href');

        $.confirm({
            title: lang.delete.title,
            content: lang.delete.content,
            theme: 'supervan',
            columnClass: 'col-md-12',
            backgroundDismiss: true,
            buttons: {
                Ja: {
                    action: function () {

                        $.ajax({
                            method: 'DELETE',
                            url: url,
                            success: function (response) {
                                console.log(response);

                                printResponse(response);
                                $(tableName).DataTable().ajax.reload(null, false)
                            },
                            error: fnToastrFormError,
                        });
                    },
                    text: formsLang.yes_no[1]
                },
                Nej: {
                    text: formsLang.yes_no[0]
                }
            }
        });
    });

    $(document).off('click', tableName + ' .btn-edit');
    $(document).on('click', tableName + ' .btn-edit', function (e) {
        e.preventDefault();

        var url = $(this).attr('data-href');
        var modalName = '#modal-update-task-template';

        if (!element_exists(modalName)) {

            $.ajax({
                url: url,
                success: function (response) {

                    $('.dynamic-modal-container').append(response);
                    $('.task-notification-container').each(function () {
                        $(this).bootstrapMaterialDesign();
                    });

                    var modal = $(modalName);

                    modal.modal('show');

                    $('select[name*=responsible_id]').select2({width: '271px', height: '75%'}).addClass('form-control');

                    const $weekdaysSelects = $('.weekdays-select');
                    $.each($weekdaysSelects, function ($weekdaysSelectKey, weekdaysSelect) {
                        const $weekdaysSelect = $(weekdaysSelect);
                        if (!$weekdaysSelect.data('select2')) {
                            $weekdaysSelect.select2();
                        }
                    });
                    addFormControlSelect2();

                    var form = $('#form-update-task-template');

                    checkFreq();

                    form.off('submit').on('submit', function (e) {
                        e.preventDefault();

                        var formData = $(this).serialize();
                        var url = this.action;

                        $.ajax({
                            type: 'POST',
                            url: url,
                            data: formData,
                            success: function (response) {
                                if (!response.error) {
                                    modal.modal('hide');
                                    $(tableName).DataTable().ajax.reload(null, false);
                                }
                                printResponse(response);
                            },
                            error: fnToastrFormError
                        })
                    });
                    modal.on('shown.bs.modal', function () {
                        modal.css('max-height', '100%'); //scroll error hack...
                    });
                    modal.on('hidden.bs.modal', function () {
                        modal.remove();
                    });
                }
            });
        }
    });


    $(document).off('click', '.btn-add-task').on('click', '.btn-add-task', function (e) {
        e.preventDefault();
        //Hacky as fuck

        var self = this;

        $.ajax({
            type: 'GET',
            url: '/task-templates/responsible-employees',
            success: function (responsible) {

                var container = $(self).parents().find('.task-template-tasks-container');
                var lang = allLangFiles['task-templates'];
                var dash_lang = allLangFiles['dashboards'];
                var count = container.find('.task-group').length++;

                var element = '<div class="task-group box-shadow-1dp p-10 m-t-10">' +
                    '<div class="form-group">' +
                    '<label for="tasks[][title]" class="bmd-label-static">' + lang.title + '</label>' +
                    '<input class="form-control" required="" name="tasks[' + count + '][title]" type="text">' +
                    '<small class="form-control-feedback text-danger"></small>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label for="tasks[][description]" class="bmd-label-static">' + lang.table.description + '</label>' +
                    '<input class="form-control" required="" name="tasks[' + count + '][description]" type="text">' +
                    '<small class="form-control-feedback text-danger"></small>' +
                    '</div>' +
                    '<div class="form-group">' +
                    '<label for="tasks[' + count + '][weekdays][]" class="bmd-label-static">' + lang.weekdays + '</label>' +
                    '<select name="tasks[' + count + '][weekdays][]" class="form-control weekdays-select" multiple="multiple">';

                    for (var k in lang.days_in_week) {
                        if (lang.days_in_week.hasOwnProperty(k)) {
                            element += '<option value="' + k + '">' + lang.days_in_week[k] + '</option>';
                        }
                    }

                    element += '</select><small class="form-control-feedback text-danger"></small>' +
                        '</div>' +
                        '<div class="form-group">' +
                        '<label for="task_status">Status</label>' +
                        '<select class="form-control" name="tasks[' + count + '][status]">';


                for (var k in lang.statuses) {
                    if (lang.statuses.hasOwnProperty(k)) {
                        element += '<option value="' + k + '">' + lang.statuses[k] + '</option>';
                    }
                }

                element += '</select>' +
                    '</div>';

                element += ' <div class="task-notification-container">' +
                    '<div class="switch switch-primary">' +
                    '<label>' +
                    '<input name="tasks[' + count + '][send_notification]" id="send_notification" type="checkbox">' +
                    dash_lang.notification.send_notification +
                    '</label>' +
                    '</div>'
                //'{!! Form::select('notification_day', __('task-templates.days_in_week'), null , ['class' => 'form-control', 'id' => 'notification_day', 'name' => 'notification_day']) !!}'+

                element += '</select>' +
                    '<br>' +
                    '<label for="frequency">' +
                    dash_lang.notification.frequency +
                    '</label>' +
                    '<select id="frequency" class="form-control" name="tasks[' + count + '][notification_recurring_week]">';
                // '{!! Form::select('frequency', __('task-templates.frequency_options'), null , ['class' => 'form-control', 'id' => 'frequency', 'name' => 'frequency']) !!}'+

                for (var k in lang.frequency_options) {
                    if (lang.frequency_options.hasOwnProperty(k)) {
                        element += '<option value="' + k + '">' + lang.frequency_options[k] + '</option>';
                    }
                }

                element += '</select>';

                element += '' +
                    '<div id="odd-or-even-week-container" style="display: block;">' +
                    '<label for="odd-or-even-week">'+ dash_lang.notification.choose_odd_or_even_week +'</label>' +
                    '<select class="form-control" id="odd-or-even-week" name="tasks[' + count + '][notification_recurring_even_week]">';

                for (var k in lang.odd_or_even_week_options) {
                    if (lang.odd_or_even_week_options.hasOwnProperty(k)) {
                        element += '<option value="' + k + '">' + lang.odd_or_even_week_options[k] + '</option>';
                    }
                }

                element += '</select></div>';

                element += '' +
                    '<div id="start-or-end-month-container" style="display: block;">' +
                    '<label for="start-or-end-month">'+ dash_lang.notification.choose_start_or_end_month +'</label>' +
                    '<select class="form-control" id="start-or-end-month" name="tasks[' + count + '][notification_recurring_start_of_month]">';

                for (var k in lang.start_or_end_month_options) {
                    if (lang.start_or_end_month_options.hasOwnProperty(k)) {
                        element += '<option value="' + k + '">' + lang.start_or_end_month_options[k] + '</option>';
                    }
                }

                element += '</select></div>';

                element += '<label for="task_responsible">' + lang.responsible + '</label><br><select class="form-control" id="task_responsible_id" name="tasks[' + count + '][responsible_id]">' + responsible.options + '</select>';

                element += '</div>';

                element += '' +
                    '<br>' +
                    '<div class="form-group">' +
                    '<button class="btn btn-danger btn-sm btn-remove-task" type="button">' + allLangFiles['forms'].delete + '</button>' +
                    '</div>' +
                    '</div>';

                container.append(element);
                $('.task-notification-container').each(function () {
                    $(this).bootstrapMaterialDesign();
                });

                checkFreq();

                const $weekdaysSelects = $('.weekdays-select');
                $.each($weekdaysSelects, function ($weekdaysSelectKey, weekdaysSelect) {
                    const $weekdaysSelect = $(weekdaysSelect);
                    if (!$weekdaysSelect.data('select2')) {
                        $weekdaysSelect.select2();
                    }
                });

                $('select[name*=responsible_id]').select2({width: '271px', height: '75%'}).addClass('form-control');
                addFormControlSelect2();
            },
            error: function (response) {

            }
        });
    });

    $(document).off('click', '.btn-remove-task').on('click', '.btn-remove-task', function (e) {
        e.preventDefault();
        $(this).parents('.task-group').remove();
    });
};
